__turbopack_context__.v({
  "check": "CheckboxInput-module__PgzJZW__check",
  "checked": "CheckboxInput-module__PgzJZW__checked",
  "container": "CheckboxInput-module__PgzJZW__container",
  "label": "CheckboxInput-module__PgzJZW__label",
  "radio": "CheckboxInput-module__PgzJZW__radio",
  "radioChecked": "CheckboxInput-module__PgzJZW__radioChecked",
});
